export default __webpack_public_path__ + "static/alexgo-3-5ac8bcdaeeff2b2e4877824c78d58109.webp";